import { render } from "./ServiceProfile.vue?vue&type=template&id=f4bf47a2"
import script from "./ServiceProfile.vue?vue&type=script&lang=js"
export * from "./ServiceProfile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__